import { defineComponent as n, createBlock as l, openBlock as i, unref as a, withCtx as o, createElementVNode as e, createCommentVNode as c, createVNode as d, createElementBlock as r, toDisplayString as m } from "vue";
import { RevButtonCard as s } from "@ds/components/ButtonCard";
import { RevIllustration as h } from "@ds/components/Illustration";
import { RevIllustrationSource as g } from "@ds/components/IllustrationSource";
const u = { class: "flex h-full flex-col items-center justify-start p-16 md:p-24 md:pt-32" }, f = { class: "mx-auto mb-32 flex max-h-full min-h-0 w-full max-w-320 justify-center sm:mb-12 md:mb-24" }, x = { class: "self-stretch text-center md:text-left" }, k = { class: "text-static-default-hi body-1" }, b = {
  key: 0,
  class: "text-static-default-low body-2 hidden md:mt-4 md:block"
}, R = /* @__PURE__ */ n({
  name: "RevCategoryCard",
  __name: "CategoryCard",
  props: {
    title: {},
    description: {},
    image: {},
    link: {},
    tracking: {}
  },
  setup(t) {
    return (w, y) => (i(), l(a(s), {
      class: "inline-block min-h-[13rem] w-full sm:min-h-[13.5rem]",
      to: t.link,
      tracking: t.tracking
    }, {
      default: o(() => [
        e("div", u, [
          e("picture", f, [
            t.image.srcMobile ? (i(), l(a(g), {
              key: 0,
              height: t.image.heightMobile || t.image.height,
              media: "(max-width: 480px)",
              src: t.image.srcMobile,
              width: t.image.widthMobile || t.image.width
            }, null, 8, ["height", "src", "width"])) : c("", !0),
            d(a(h), {
              alt: t.image.alt,
              class: "block object-contain",
              height: t.image.height,
              src: t.image.src,
              width: t.image.width
            }, null, 8, ["alt", "height", "src", "width"])
          ]),
          e("div", x, [
            e("h2", k, m(t.title), 1),
            t.description ? (i(), r("span", b, m(t.description), 1)) : c("", !0)
          ])
        ])
      ]),
      _: 1
    }, 8, ["to", "tracking"]));
  }
});
export {
  R as default
};
